<template>
  <div>
    <!-- 商品管理添加商品 -->
    <el-dialog :close-on-click-modal="false"
      title="添加商品"
      :visible.sync="addShopVisible"
      :before-close="addShopHandleClose"
      width="55.4%"
      center
    >
      <el-divider></el-divider>
      <div>
        <div class="contentQp">
          <div class="qpLeft">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="qpCenter">
            <div>
              <el-form ref="form" :model="form" label-width="80px" :label-position="labelPosition">
                <el-form-item label="商品价格">
                  <el-input v-model="form.name" placeholder="数量"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div class="qpCenterBtn">
              <div>
                <button>选择</button>
                <div>
                  <el-checkbox
                    :indeterminate="isIndeterminate"
                    v-model="checkAll"
                    @change="handleCheckAllChange"
                  >全部选择</el-checkbox>
                </div>
                <!-- <button>全部选择</button> -->
              </div>
            </div>
          </div>
          <div class="qpRight">
            <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
              <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="itemBtnS">
          <el-button>清空</el-button>
          <el-button class="btnL">确认授权</el-button>
        </div>
      </div>
    </el-dialog>
    <!--退票管理订单详情 -->
    <el-dialog :close-on-click-modal="false"
      title="订单详情"
      :visible.sync="tickInfoVisible"
      :before-close="tickInfoHandleClose"
      width="49.4%"
      center
    >
      <el-divider></el-divider>
      <div class="infoForm">
        <el-form ref="form" :model="form" label-width="110px">
          <div class="itemOne">
            <div>
              <el-form-item label="订单号:">
                <el-input v-model="form.name" placeholder="订单号"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="微商城订单号:">
                <el-input v-model="form.name" placeholder="微商城订单号"></el-input>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="产品名称:">
            <el-input v-model="form.name" placeholder="产品名称"></el-input>
          </el-form-item>
          <div class="itemTwo">
            <el-form-item label="产品单价:">
              <el-input v-model="form.name" placeholder="产品单价"></el-input>
            </el-form-item>
            <el-form-item label="购买数量:">
              <el-input v-model="form.name" placeholder="购买数量"></el-input>
            </el-form-item>
            <el-form-item label="总价格:">
              <el-input v-model="form.name" placeholder="总价格"></el-input>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="已使用:">
              <el-input v-model="form.name" placeholder="数量"></el-input>
            </el-form-item>
            <el-form-item label="未使用:">
              <el-input v-model="form.name" placeholder="数量"></el-input>
            </el-form-item>
            <el-form-item label="已退票数量:">
              <el-input v-model="form.name" placeholder="数量"></el-input>
            </el-form-item>
            <el-form-item label="待退票数量:">
              <el-input v-model="form.name" placeholder="数量"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
const cityOptions = ["爱上咖啡哈萨克好尬水开关", "北京", "广州", "深圳"];
export default {
  data() {
    return {
      addShopVisible: false, // 商品管理添加商品
      tickInfoVisible: false, // 退票管理订单详情
      form: {
        name: ""
      },
      labelPosition: "top",
      checkAll: false,
      checkedCities: ["上海", "北京"],
      cities: cityOptions,
      isIndeterminate: true
    };
  },
  methods: {
    // 退票管理订单详情
    tickInfo() {
      this.tickInfoVisible = true;
    },
    // 退票管理订单详情X
    tickInfoHandleClose() {
      this.tickInfoVisible = false;
    },
    // 商品管理添加商品
    addShop() {
      this.addShopVisible = true;
    },
    // 商品管理添加商品X
    addShopHandleClose() {
      this.addShopVisible = false;
    },
    // 全部选择
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    }
  }
};
</script>

<style lang='less' scoped>
.infoForm {
  .itemThree {
    display: flex;
    .el-input {
      width: 117px;
    }
  }
  .itemTwo {
    display: flex;
    .el-input {
      width: 193px;
    }
  }
  .itemOne {
    display: flex;
    > div:nth-child(1) {
      .el-input {
        width: 240px;
      }
    }
    > div:nth-child(2) {
      .el-input {
        width: 448px;
      }
    }
  }
}
.itemBtnS {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 20px;
  /deep/.el-button {
    width: 100px;
    height: 40px;
    background: #d9d9d9;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
    border: none;
  }
  .btnL {
    width: 100px;
    height: 40px;
    background: #246deb;
    border-radius: 4px;
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    color: #ffffff;
  }
}
.contentQp {
  width: 100%;
  height: 490px;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  .qpLeft {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    /deep/.el-checkbox {
      width: 100%;
      margin-bottom: 15px;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
  .qpCenter {
    width: 15%;
    height: 450px;
    background: #ffffff;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    flex-direction: column;

    .qpCenterBtn {
      margin-top: 70px;
      > div:nth-child(1) {
        width: 100%;
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > div:nth-child(2) {
          background: #ffffff;
          width: 140px;
          height: 40px;
          border: 1px solid #246deb;
          border-radius: 4px;
          text-align: center;
          line-height: 40px;
          color: #409eff;
          margin-top: 70px;
          /deep/.el-checkbox__input .el-checkbox__inner,
          .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            // background-color: #409eff;
            // border-color: #409eff;
            display: none;
            color: #409eff;
          }
        }
        button {
          width: 140px;
          height: 40px;
          background: #ffffff;
          border: 1px solid #246deb;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #246deb;
          cursor: pointer;
          margin-bottom: 20px;
        }
      }
      > div:nth-child(2) {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        button {
          width: 140px;
          height: 40px;
          background: #ffffff;
          border: 1px solid #e74c3c;
          border-radius: 4px;
          font-family: "OPPOSans";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          color: #e74c3c;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
    }
    /deep/.el-form-item {
      margin-bottom: 10px;
    }
    /deep/.el-form-item__label {
      text-align: right;
      vertical-align: middle;
      float: left;
      line-height: 30px;
      padding: 0 12px 0 0;
      box-sizing: border-box;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
    }
  }
  .qpRight {
    width: 40%;
    height: 490px;
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    /deep/.el-checkbox {
      width: 100%;
      margin-bottom: 15px;
    }
    /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #4ecb73;
      border-color: #4ecb73;
    }
    /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      /* identical to box height */
      color: #666666;
    }
  }
}
</style>